import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { PageTitle, Panel, Field, TextInput, TextArea, Btn, StatCard } from "../components/ui";
import { useI18n } from "../i18n";
import { CL } from "../api";

export default function Esrs() {
  const { t } = useI18n();
  const [d, setD] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { CL.getEsrs().then(setD).catch(() => {}); }, []);
  if (!d) return null;
  const a = d.auto || {};
  const up = (k) => (e) => { const v = e.target.value; setD((p) => ({ ...p, [k]: v })); };
  const num = (v) => (v === "" || v == null ? 0 : Number(v));

  const save = async () => {
    setSaving(true);
    try {
      await CL.putEsrs({ transition_plan: d.transition_plan || "", energy_kwh: num(d.energy_kwh),
        renewable_pct: num(d.renewable_pct), policies: d.policies || "", note: d.note || "" });
      toast.success(t("saved"));
    } catch { toast.error("Error"); } finally { setSaving(false); }
  };

  return (
    <div data-testid="esrs-page">
      <PageTitle title={t("esrsTitle")} subtitle={t("esrsDesc")} />
      <div className="mb-6 grid grid-cols-2 gap-4 md:grid-cols-4">
        <StatCard testId="esrs-s1" label={t("scope1")} value={(a.scope1_t ?? 0).toLocaleString()} sub={t("tCO2e")} />
        <StatCard testId="esrs-s2" label={t("scope2")} value={(a.scope2_t ?? 0).toLocaleString()} sub={t("tCO2e")} accent="#2f8f5b" />
        <StatCard testId="esrs-s3" label={t("scope3")} value={(a.scope3_t ?? 0).toLocaleString()} sub={t("tCO2e")} accent="#e08a1e" />
        <StatCard testId="esrs-int" label={t("intensityMetric")} value={a.intensity_per_meur ?? "—"} />
      </div>
      <Panel className="max-w-3xl">
        <Field label={t("transitionPlan")}><TextArea data-testid="esrs-plan" value={d.transition_plan || ""} onChange={up("transition_plan")} /></Field>
        <div className="mt-4 grid grid-cols-2 gap-5">
          <Field label={t("energyKwh")}><TextInput type="number" data-testid="esrs-energy" value={d.energy_kwh ?? ""} onChange={up("energy_kwh")} /></Field>
          <Field label={t("renewablePct")}><TextInput type="number" data-testid="esrs-renew" value={d.renewable_pct ?? ""} onChange={up("renewable_pct")} /></Field>
        </div>
        <div className="mt-4"><Field label={t("policies")}><TextArea data-testid="esrs-policies" value={d.policies || ""} onChange={up("policies")} /></Field></div>
        <div className="mt-6"><Btn onClick={save} disabled={saving} data-testid="esrs-save">{saving ? "..." : t("save")}</Btn></div>
      </Panel>
    </div>
  );
}
